import lagosFintech from "./lagos-fintech";
import dakarGtm from "./dakar-gtm";
import saoPauloSaas from "./luanda-saas";
import casablancaCommerce from "./casablanca-commerce";
import nairobiAgritech from "./nairobi-agritech";
import remoteOps from "./remote-ops";
import abidjanFreshkart from "./abidjan-freshkart";
import dakarWave from "./dakar-wave";
import saoPauloMetapag from "./luanda-metapag";
import type { CaseStudy } from "./types";

export const CASE_STUDIES: CaseStudy[] = [
  lagosFintech,
  dakarGtm,
  saoPauloSaas,
  casablancaCommerce,
  nairobiAgritech,
  remoteOps,
  abidjanFreshkart,
  dakarWave,
  saoPauloMetapag,
];

export function getCaseStudy(slug: string): CaseStudy | undefined {
  return CASE_STUDIES.find((c) => c.slug === slug);
}

export type { CaseStudy };
